<div id="ht">
  <div id="main-cnt">

    <ion-content class="main-content">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content">
            <!-- edit da qui... -->
            <form (ngSubmit)="savePayment()" [formGroup]="paymentForm">
              <div>
                <!-- <ion-input *ngIf="client" disabled="true" placeholder="Intestatario" class="text-input"
                            type="text" value="{{client.lastname+' '+ client.name}}"></ion-input>-->
                <ion-label position="floating">Selezione Commerciale</ion-label>
                <ion-select [compareWith]="compareWith"
                            class="inputItem item-leave-height no-arrow"
                            class="text-input" interface="action-sheet" formControlName="user"
                            placeholder="Select Client">
                  <ion-select-option *ngFor="let client of commerciali"
                                     [value]="client">{{client.name |titlecase}} {{client.lastname |titlecase}}</ion-select-option>
                </ion-select>
              </div>
              <ion-label class="addInput-Label" position="floating">Data</ion-label>
              <ion-input placeholder="Data" class="text-input" formControlName="date"
                         type="date"></ion-input>
              <ion-label class="addInput-Label" position="floating">Data Pagamento</ion-label>
              <ion-input placeholder="Data" class="text-input" formControlName="payDate"
                         type="date"></ion-input>
              <ion-label position="floating">Info</ion-label>
              <ion-input placeholder="Info" class="text-input" formControlName="type"
                         type="text"></ion-input>

              <ion-label position="floating">Tipologia Bonus</ion-label>
              <ion-select   interface="action-sheet" class="inputItem item-leave-height no-arrow" formControlName="typeEnum"
              >
                <ion-select-option *ngFor="let b of bonusTypeList" value="{{b}}">{{b}}</ion-select-option>
              </ion-select>



                <ion-label position="floating">Importo</ion-label>
                <ion-input placeholder="Importo" class="text-input" formControlName="total"
                           type="text"></ion-input>
              <ion-label position="floating">Stato</ion-label>
              <ion-select  class="text-input" interface="action-sheet" placeholder="Enter contract status"
                          formControlName="status"
              >
                <ion-select-option  *ngFor="let status of bonusStatusList" [value]="status"
                                    disabled="true ">{{status}}</ion-select-option>
              </ion-select>


                <button expand="block" type="submit"
                        class="button glass-blurred-background drop-shadow padding">Save
                </button>


            </form>

            <!-- ...a qui -->
          </div>
        </div>
      </div>
    </ion-content>

  </div>
</div>